import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { Enterprise } from 'app/models/enterprise.model';
import { Role, User } from 'app/models/user.model';
import { UserService } from 'app/services/users/user.service';
import { Router } from '@angular/router';
import { error } from 'protractor';
import { EnterpriseService } from 'app/services/enterprise/enterprise.service';

declare const swal: any;

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css'],
  providers: [{
    provide: MAT_STEPPER_GLOBAL_OPTIONS, useValue: {showError: true}
  }]

})
export class RegisterComponent implements OnInit {

  isLinear = false;
  userForm: FormGroup;
  enterpriseForm: FormGroup;
  passwordValue = false;

  constructor(private formBuilder: FormBuilder, 
    private userService: UserService,
    private enterpriseService: EnterpriseService,
    private router: Router) { }

  ngOnInit() {
    this.loadForms();
  }

  loadForms(){
    this.userForm = this.formBuilder.group({
      email: ['', Validators.required],
      password: ['', Validators.required],
      passwordConfirmation: ['', Validators.required]
    })

    this.enterpriseForm = this.formBuilder.group({
      name: ['', Validators.required],
      lastName: ['', Validators.required],
      phone: ['', Validators.required],
      mobile: ['', Validators.required],
      address: ['', Validators.required],
      enterpriseName: ['', Validators.required]
    })
  }

  confirmPassword(){
    if(this.userForm.value.password == this.userForm.value.passwordConfirmation){
      console.log('password coincide!');
      this.passwordValue = true;
    }else{
      this.passwordValue = false;
      console.log('password no coincide!')
    }
  }

  async register(){
    let enterprise: Enterprise = this.enterpriseForm.value;
    let user: {email: string, password: string, role: Role} = {email: this.userForm.value.email, password: this.userForm.value.password, role: "enterprise"};
    // console.log(user);
    try {
      let newUser: User = await this.userService.register(user.email, user.password, user.role);
      if(newUser){
        enterprise.user_uid = newUser.uid;
        enterprise.email = this.userForm.value.email;
        this.enterpriseService.saveEnterprise(enterprise).subscribe(result => {
          console.log('Empresa creada en api! -> ', result);
          let userToUpdate: User = newUser;
          userToUpdate.databaseId = result.id;
          console.log('user to update', userToUpdate);
          // userToUpdate.displayName = result.name + ' ' + result.lastName
          this.userService.updateUserData(userToUpdate);
        })
        this.router.navigate(['/verification']);
      }
      // console.log('nuevo usuario -> ', newUser);
    } catch (error) {
      console.error('Error al crear usuario -> ',error);
    }
  }


  openAlert(type){
    switch (type) {
      case 1:
        swal({
          title: 'Guardado correctamente',
          text: 'Presiona OK para continuar',
          type: 'success',
          timer: 3000,
          showConfirmButton: false
        })
        break;
      case 0:
        swal({
          title: 'Atención',
          text: 'Debes llenar todos los campos requeridos',
          type: 'warning',
          confirmButtonClass: 'btn btn-danger'
        })
    }
  }

}
